// Services.js
import { motion } from "framer-motion";
import { FaCashRegister, FaFileInvoiceDollar, FaChartLine, FaShieldAlt } from "react-icons/fa";

const services = [
  {
    title: "نظام نقاط البيع",
    description: "حلول كاشير متكاملة لإدارة المبيعات اليومية بسهولة وسرعة.",
    icon: <FaCashRegister size={40} className="text-yellow-400" />,
  },
  {
    title: "الفوترة الإلكترونية",
    description: "مولد فواتير متوافق مع هيئة الزكاة والدخل ويعمل بشكل آلي.",
    icon: <FaFileInvoiceDollar size={40} className="text-green-400" />,
  },
  {
    title: "تقارير تحليلية",
    description: "تقارير احترافية لمتابعة المبيعات والمخزون واتخاذ قرارات ذكية.",
    icon: <FaChartLine size={40} className="text-blue-400" />,
  },
  {
    title: "أمان وحماية",
    description: "نظام مشفر لحماية بياناتك وضمان السرية التامة في العمليات.",
    icon: <FaShieldAlt size={40} className="text-red-400" />,
  },
  {
    title: "رفع الفواتير للهيئة",
    description: "نظام تلقائي لرفع الفواتير الإلكترونية ومتابعة حالتها لحظة بلحظة مع عرض تنبيهات بالأخطاء.",
    icon: <FaFileInvoiceDollar size={40} className="text-purple-500" />,
  },
  {
    title: "خدمة VIP لمتابعة الفواتير",
    description: "نظام متابعة خاص لفواتير العملاء يتيح لك مراقبة حالات الفواتير لحظة بلحظة، مع إشعارات فورية عند القبول أو الرفض من الهيئة.",
    icon: <FaShieldAlt size={40} className="text-pink-500" />,
  },
  {
    title: "لوحة تحكم ضريبية",
    description: "تمنحك رؤية كاملة لجميع فواتير الزكاة والضريبة، مع تتبع دقيق لكل حالة (تم الإرسال - بانتظار - تم الرفض) وتحليل زمني لسرعة التنبيه.",
    icon: <FaChartLine size={40} className="text-indigo-500" />,
  },
  {
    title: "تنبيهات ذكية لحالة الفواتير",
    description: "نرسل لك تنبيهات تلقائية لحالة كل فاتورة على النظام، بما في ذلك وقت الرفع والاستجابة من هيئة الزكاة لتتخذ الإجراء المناسب فورًا.",
    icon: <FaFileInvoiceDollar size={40} className="text-amber-500" />,
  },

];

export default function Services() {
  return (
    <section id="services" className="py-20 px-8 bg-white text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">خدماتنا</h2>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {services.map((service, idx) => (
          <motion.div
            key={idx}
            dir="rtl"

            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: idx * 0.2 }}
            viewport={{ once: true }}
            className="bg-blue-50 rounded-xl shadow-md p-6 hover:shadow-xl hover:-translate-y-2 transition-all"
          >
            <motion.div
              whileHover={{ scale: 1.2, rotate: 10 }}
              className="mb-4 flex justify-center"
            >
              {service.icon}
            </motion.div>
            <h3 className="text-xl font-semibold mb-2 text-blue-800">{service.title}</h3>
            <p className="text-gray-600 text-sm">{service.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
